import React from 'react';

import { AccountContextType } from './types';

export const AccountContext = React.createContext<AccountContextType>({} as AccountContextType);
